var ProductionCurrency;
(function (ProductionCurrency) {
    ProductionCurrency[ProductionCurrency["GOLD"] = 1] = "GOLD";
    ProductionCurrency[ProductionCurrency["FOOD"] = 2] = "FOOD";
    ProductionCurrency[ProductionCurrency["CURRENT_ERA_PRIMARY_GOODS"] = 3] = "CURRENT_ERA_PRIMARY_GOODS";
    ProductionCurrency[ProductionCurrency["CURRENT_ERA_SECONDARY_GOODS"] = 4] = "CURRENT_ERA_SECONDARY_GOODS";
    ProductionCurrency[ProductionCurrency["CURRENT_ERA_TERTIARY_GOODS"] = 5] = "CURRENT_ERA_TERTIARY_GOODS";
    ProductionCurrency[ProductionCurrency["PREVIOUS_ERA_PRIMARY_GOODS"] = 6] = "PREVIOUS_ERA_PRIMARY_GOODS";
    ProductionCurrency[ProductionCurrency["PREVIOUS_ERA_SECONDARY_GOODS"] = 7] = "PREVIOUS_ERA_SECONDARY_GOODS";
    ProductionCurrency[ProductionCurrency["PREVIOUS_ERA_TERTIARY_GOODS"] = 8] = "PREVIOUS_ERA_TERTIARY_GOODS";
    ProductionCurrency[ProductionCurrency["RESEARCH_POINTS"] = 9] = "RESEARCH_POINTS";
    ProductionCurrency[ProductionCurrency["INFANTRY_UNITS"] = 10] = "INFANTRY_UNITS";
    ProductionCurrency[ProductionCurrency["RANGED_UNITS"] = 11] = "RANGED_UNITS";
    ProductionCurrency[ProductionCurrency["GEARS"] = 12] = "GEARS";
})(ProductionCurrency || (ProductionCurrency = {}));
export default ProductionCurrency;
